import React, { FC, useEffect } from "react";

import { StyledMap } from "../Map/styled";
import { LayersLoader } from "../Map/components/LayersLoader/LayersLoader";
import { Basemap } from "./components/Basemap";
import { Copyright } from "./components/Copyright";
import { SharedLayers } from "./components/SharedLayers";
import { PrintArea } from "../PrintArea/PrintArea";

import { useSyncProjectView } from "../../hooks/project/useSyncProjectView";
import { useSharedProject } from "../../hooks/sharing/useSharedProject";
import { useNavigatorGeolocation } from "../../hooks/useNavigatorGeolocation";
import { useDefaultProjectContent } from "../../hooks/project/useDefaultProjectContent";
import { useMapView } from "../../ducks/mapView/useMapView";

export const SharedMap: FC = ({ children }) => {
  const [{ position, resolution }, set] = useMapView();
  const projectView = useSharedProject();
  const mapState = position === null && resolution === null ? projectView.content : { position, resolution };
  const positionFromDevice = useNavigatorGeolocation();
  const defaultProjectContent = useDefaultProjectContent();

  useEffect(() => {
    if (positionFromDevice) {
      set({
        position: positionFromDevice,
        resolution: defaultProjectContent.resolution,
      });
    }
  }, [defaultProjectContent.resolution, positionFromDevice]);

  useSyncProjectView(mapState);

  return (
    <StyledMap position={position} resolution={resolution} onBboxChange={set}>
      <LayersLoader />
      <Basemap />
      <SharedLayers />
      <Copyright />
      <PrintArea />
      {children}
    </StyledMap>
  );
};
